<template>
  <div class="resume-extra-charge">
    <p v-if="title" class="resume__title semibold">{{ title }}</p>
    <resume-extra-item
      v-for="(item, index) in extra"
      :key="_uid+'_item_'+index"
      :extra="item"
    />
  </div>
</template>

<script>
import ResumeExtraItem from "@bookingv3/components/blocks/resume/resume-extra-item"

export default {
  name: 'resume-not-chargeable',

  components: {
    'resume-extra-item': ResumeExtraItem
  },

  props: {
    title: {
      type: String,
      default: '',
    },
    extra: Array,
  },

  data() {
    return {
    }
  },

  computed: {
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>
</style>